import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9 8a1 1 0 000 2h.01a1 1 0 000-2H9zm6 0a1 1 0 100 2h.01a1 1 0 100-2H15zm-7.6 5.2a1 1 0 011.397.196l.005.006.033.041a4.945 4.945 0 00.815.748c.578.42 1.376.81 2.35.81.975 0 1.772-.39 2.35-.81a4.945 4.945 0 00.815-.748l.034-.041.004-.006A1 1 0 0116.8 14.6L16 14l.799.601-.001.002-.003.004-.007.009-.021.027-.07.086c-.059.07-.142.164-.248.276a6.951 6.951 0 01-.923.804c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.949 6.949 0 01-1.17-1.08 3.884 3.884 0 01-.07-.086l-.022-.027-.007-.01-.003-.003V14.6H7.2a1 1 0 01.2-1.4z',
    ],
};
const IconHappy = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconHappy.displayName = 'IconHappy';

export { IconHappy };
//# sourceMappingURL=IconHappy.js.map
